enum RoomStatus {
  WaitingForJoining,
  WaitingForReadiness,
  Playing,
  GameOver
}
export default RoomStatus